import { greaterEqualThan, packValidateResults, required } from 'helpers/validators';
import { RequestSettlementBody } from 'services/API/Settlement/interface';
import { default as currencies, translateCurrency } from 'constants/Currencies';

type Currency = typeof currencies;
type CurrencyKey = keyof Currency;

function currencyThreshold(currency: string): number {
  switch (currency) {
    case currencies.USD.value:
      return 50;
    default:
      return 300;
  }
}

export const validate = (data: RequestSettlementBody, language = 'en') =>
  packValidateResults([
    required(data, ['amount', 'currency']),
    ...(data.currency
      ? [
          greaterEqualThan(data, 'amount', {
            min: currencyThreshold(data.currency),
            err_msg: [
              'error_must_be_greater_equal_than_currency',
              [
                currencyThreshold(data.currency),
                translateCurrency(currencies[data.currency as CurrencyKey]?.value, language),
              ],
            ],
          }),
        ]
      : []),
  ]);
